<template>
  <div>
    <CreateUpdateTemplate
      :routePreventDialog="routePreventDialog"
      :customClass="'customer-create create-form'"
      v-if="getPermission('claim:create')"
    >
      <template v-slot:header-title>
        <h1 class="form-title d-flex">
          {{ isEditMode ? "Update Claim" : "Create a new Claim" }}
          <SystemGenerateId
            v-if="barcode"
            :system-id="barcode"
          ></SystemGenerateId>
        </h1>
      </template>

      <template v-slot:header-action>
        <v-btn
          v-on:click="goBack"
          :disabled="formLoading"
          outlined
          color="grey darken-2"
          class="mx-2 custom-grey-border custom-bold-button rounded-lg px-4 text-capitalize"
        >
          <v-icon left small>mdi-arrow-left</v-icon>
          Cancel
        </v-btn>

        <v-btn
          :disabled="!formValid || formLoading"
          :loading="formLoading"
          depressed
          color="cyan darken-1"
          class="mx-2 custom-bold-button white--text rounded-lg px-6 text-capitalize"
          v-on:click="onSubmit('approval')"
        >
          <v-icon left small>mdi-content-save-outline</v-icon>
          {{ isEditMode ? "Update" : "Save" }}
        </v-btn>
      </template>
      <template v-slot:body>
        <v-row dense>
          <!-- Claim Summary Sidebar -->
          <v-col cols="12" md="3" class="pr-md-2 pt-0 mb-4 mb-md-0">
            <v-card outlined class="rounded-lg pa-3 h-100 grey lighten-5">
              <perfect-scrollbar
                :options="{ suppressScrollX: true }"
                class="scroll pr-1"
                style="max-height: calc(100vh - 200px); position: relative"
              >
                <v-form
                  ref="createQuotationForm"
                  v-model.trim="formValid"
                  lazy-validation
                  v-on:submit.stop.prevent="onSubmit()"
                >
                  <div class="d-flex align-center mb-3 px-1">
                    <v-icon color="cyan darken-2" small class="mr-2"
                      >mdi-chart-timeline-variant</v-icon
                    >
                    <span
                      class="text-subtitle-1 font-weight-bold grey--text text--darken-4 text-uppercase"
                    >
                      Claim Summary
                    </span>
                  </div>

                  <table class="mt-0" width="100%">
                    <tbody>
                      <!-- Employee Card -->
                      <tr v-if="detail.engineer && selectedEmployee">
                        <td colspan="2" class="font-weight-medium py-1">
                          <v-card
                            class="pa-3 rounded-lg white left-border-green shadow-sm mb-2"
                            outlined
                          >
                            <div
                              class="d-flex align-center justify-content-between mb-2 pb-1 border-bottom"
                            >
                              <div class="d-flex align-center">
                                <v-icon
                                  small
                                  color="green darken-1"
                                  class="mr-2"
                                  >mdi-account-tie-outline</v-icon
                                >
                                <span
                                  class="text-subtitle-1 font-weight-bold green--text text--darken-2"
                                >
                                  Employee
                                </span>
                              </div>
                              <v-chip
                                label
                                x-small
                                color="blue"
                                outlined
                                class="font-weight-bold"
                                v-if="selectedEmployee.barcode"
                              >
                                {{ selectedEmployee.barcode }}
                              </v-chip>
                            </div>
                            <div
                              class="text-subtitle-1 font-weight-bold black--text mb-1"
                            >
                              {{ selectedEmployee.name }}
                              <v-chip
                                v-if="
                                  selectedEmployee &&
                                  selectedEmployee.designation
                                "
                                text-color="white"
                                label
                                x-small
                                color="green darken-1"
                                class="ml-1 font-weight-bold"
                              >
                                {{ selectedEmployee.designation }}
                              </v-chip>
                            </div>
                            <div
                              class="grey--text text--darken-2 text-caption-1"
                            >
                              <div
                                class="d-flex align-center mb-1 hover-effect"
                                v-if="
                                  selectedEmployee &&
                                  selectedEmployee.primary_email
                                "
                              >
                                <v-icon
                                  small
                                  color="green darken-1"
                                  class="mr-2"
                                  >mdi-email-outline</v-icon
                                >
                                <span class="text-truncate font-size-16">{{
                                  selectedEmployee.primary_email
                                }}</span>
                              </div>

                              <div
                                class="d-flex align-center hover-effect"
                                v-if="
                                  selectedEmployee &&
                                  selectedEmployee.primary_phone
                                "
                              >
                                <v-icon
                                  small
                                  color="green darken-1"
                                  class="mr-2"
                                  >mdi-phone-outline</v-icon
                                >
                                <span class="font-size-16">{{
                                  selectedEmployee.primary_phone
                                }}</span>
                              </div>
                            </div>
                          </v-card>
                        </td>
                      </tr>

                      <!-- Visit Info Card -->
                      <tr
                        v-if="
                          (detail.expense_category == 3 ||
                            detail.expense_category == 4) &&
                          detail.visit > 0
                        "
                      >
                        <td class="font-weight-medium py-1" colspan="2">
                          <v-card
                            class="pa-3 rounded-lg white left-border-blue shadow-sm mb-2"
                            outlined
                          >
                            <div
                              class="d-flex align-center justify-content-between mb-2 pb-1 border-bottom"
                            >
                              <div class="d-flex align-center">
                                <v-icon small color="blue darken-1" class="mr-2"
                                  >mdi-file-document-outline</v-icon
                                >
                                <span
                                  class="text-subtitle-2 font-weight-bold blue--text text--darken-2"
                                >
                                  Visit Info
                                </span>
                              </div>
                              <v-chip
                                label
                                x-small
                                color="blue darken-1"
                                outlined
                                class="font-weight-bold"
                                v-if="selectedVisit && selectedVisit.barcode"
                              >
                                {{ selectedVisit.barcode }}
                              </v-chip>
                            </div>

                            <div
                              class="d-flex justify-space-between align-center mb-2"
                            >
                              <span
                                class="grey--text text--darken-1 text-caption-1 font-weight-medium"
                                >Title</span
                              >
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <span
                                    v-bind="attrs"
                                    v-on="on"
                                    class="font-weight-bold text-caption-1 black--text text-truncate"
                                    style="max-width: 140px"
                                  >
                                    {{
                                      selectedVisit
                                        ? selectedVisit.visit_title
                                        : "—"
                                    }}
                                  </span>
                                </template>
                                <span>{{ selectedVisit?.visit_title || "—" }}</span>
                              </v-tooltip>
                            </div>

                            <!-- Site Location -->
                            <v-card
                              flat
                              class="pa-2 rounded-lg grey lighten-5 border mb-2"
                            >
                              <div
                                class="text-caption-1 font-weight-bold orange--text text--darken-3 mb-1"
                              >
                                Site Location
                              </div>
                              <div
                                class="text-caption-1 grey--text text--darken-3"
                              >
                                <div>
                                  {{
                                    selectedVisit && selectedVisit.site_location
                                      ? selectedVisit.site_location
                                      : "—"
                                  }}
                                </div>
                                <a
                                  v-if="
                                    selectedVisit && selectedVisit.site_location
                                  "
                                  class="blue--text text--darken-1 text-caption-1 d-block mt-1"
                                  :href="
                                    'https://www.google.com/maps/search/?api=1&query=' +
                                    encodeURIComponent(
                                      selectedVisit.site_location
                                    )
                                  "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style="text-decoration: none"
                                >
                                  <v-icon
                                    x-small
                                    color="blue darken-1"
                                    class="mr-1"
                                    >mdi-open-in-new</v-icon
                                  >
                                  View on Map
                                </a>
                              </div>
                            </v-card>

                            <!-- Contact Person -->
                            <v-card
                              flat
                              class="pa-2 rounded-lg grey lighten-5 border mb-2"
                            >
                              <div
                                class="text-caption-1 font-weight-bold green--text text--darken-2 mb-1"
                              >
                                Contact Person
                              </div>
                              <div
                                class="text-caption-1 grey--text text--darken-3"
                                v-if="
                                  selectedVisit && selectedVisit.contact_person
                                "
                              >
                                <div
                                  class="d-flex align-center font-weight-bold black--text mb-1"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-account-outline</v-icon
                                  >
                                  {{
                                    selectedVisit.contact_person.display_name ||
                                    selectedVisit.contact_person.name
                                  }}
                                </div>
                                <div
                                  v-if="
                                    selectedVisit.contact_person.primary_email
                                  "
                                  class="d-flex align-center mb-1"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-email-outline</v-icon
                                  >
                                  <span class="text-truncate">{{
                                    selectedVisit.contact_person.primary_email
                                  }}</span>
                                </div>
                                <div
                                  v-if="
                                    selectedVisit.contact_person.primary_phone
                                  "
                                  class="d-flex align-center"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-phone-outline</v-icon
                                  >
                                  <span>{{
                                    selectedVisit.contact_person.primary_phone
                                  }}</span>
                                </div>
                              </div>
                              <em v-else class="text-caption-1 grey--text"
                                >No contact person</em
                              >
                            </v-card>

                            <!-- Project Details -->
                            <v-card
                              v-if="selectedVisit?.project_details"
                              flat
                              class="pa-2 rounded-lg grey lighten-5 border"
                            >
                              <div
                                class="d-flex align-center justify-space-between mb-1"
                              >
                                <span
                                  class="text-caption-1 font-weight-bold cyan--text text--darken-2"
                                  >Project Details</span
                                >
                                <v-chip
                                  x-small
                                  label
                                  color="blue darken-1"
                                  outlined
                                  class="font-weight-bold"
                                >
                                  {{
                                    selectedVisit?.project_details
                                      .project_barcode
                                  }}
                                </v-chip>
                              </div>
                              <div
                                class="text-caption-1 grey--text text--darken-3"
                              >
                                <div>
                                  <strong class="black--text">Name:</strong>
                                  {{
                                    selectedVisit?.project_details
                                      ?.project_name || "—"
                                  }}
                                </div>
                                <div>
                                  <strong class="black--text">PIC:</strong>
                                  {{
                                    selectedVisit?.project_details
                                      ?.project_pic || "—"
                                  }}
                                </div>
                              </div>
                            </v-card>
                          </v-card>
                        </td>
                      </tr>

                      <!-- Project Info Card -->
                      <tr
                        v-if="
                          detail.expense_category == 3 && detail.project > 0
                        "
                      >
                        <td colspan="2" class="font-weight-medium py-1">
                          <v-card
                            class="pa-3 rounded-lg white left-border-orange shadow-sm mb-2"
                            outlined
                          >
                            <div
                              class="d-flex align-center justify-space-between mb-2 pb-1 border-bottom"
                            >
                              <div class="d-flex align-center">
                                <v-icon
                                  small
                                  color="orange darken-2"
                                  class="mr-2"
                                  >mdi-briefcase-outline</v-icon
                                >
                                <span
                                  class="text-subtitle-1 font-weight-bold orange--text text--darken-3"
                                >
                                  Project Info
                                </span>
                              </div>
                              <v-chip
                                label
                                small
                                color="orange darken-2"
                                outlined
                                class="font-weight-bold"
                                v-if="
                                  selectedProject && selectedProject.barcode
                                "
                              >
                                {{ selectedProject.barcode }}
                              </v-chip>
                            </div>

                            <div
                              class="d-flex justify-space-between align-center mb-2"
                            >
                              <span
                                class="grey--text text--darken-1 text-caption-1 font-weight-medium"
                                >Title</span
                              >
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <span
                                    v-bind="attrs"
                                    v-on="on"
                                    class="font-weight-bold text-caption-1 black--text text-truncate"
                                    style="max-width: 140px"
                                  >
                                    {{ selectedProject?.project_name || "—" }}
                                  </span>
                                </template>
                                <span>{{ selectedProject?.project_name || "—" }}</span>
                              </v-tooltip>
                            </div>

                            <!-- Site Address -->
                            <v-card
                              flat
                              class="pa-2 rounded-lg grey lighten-5 border mb-2"
                            >
                              <div
                                class="text-caption-1 font-weight-bold purple--text text--darken-2 mb-1"
                              >
                                Site Location
                              </div>
                              <div
                                class="text-caption-1 grey--text text--darken-3"
                              >
                                <div>
                                  {{
                                    selectedProject &&
                                    selectedProject.site_location
                                      ? selectedProject.site_location
                                      : "—"
                                  }}
                                </div>
                                <a
                                  v-if="
                                    selectedProject &&
                                    selectedProject.site_location
                                  "
                                  class="blue--text text--darken-1 text-caption-1 d-block mt-1"
                                  :href="
                                    'https://www.google.com/maps/search/?api=1&query=' +
                                    encodeURIComponent(
                                      selectedProject.site_location
                                    )
                                  "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style="text-decoration: none"
                                >
                                  <v-icon
                                    x-small
                                    color="blue darken-1"
                                    class="mr-1"
                                    >mdi-open-in-new</v-icon
                                  >
                                  View on Map
                                </a>
                              </div>
                            </v-card>

                            <!-- Contact Person -->
                            <v-card
                              flat
                              class="pa-2 rounded-lg grey lighten-5 border"
                            >
                              <div
                                class="text-caption-1 font-weight-bold green--text text--darken-2 mb-1"
                              >
                                Contact Person
                              </div>
                              <div
                                class="text-caption-1 grey--text text--darken-3"
                                v-if="
                                  selectedProject &&
                                  selectedProject.contact_person
                                "
                              >
                                <div
                                  class="d-flex align-center font-weight-bold black--text mb-1"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-account-outline</v-icon
                                  >
                                  {{
                                    selectedProject.contact_person
                                      .display_name ||
                                    selectedProject.contact_person.name
                                  }}
                                </div>
                                <div
                                  v-if="
                                    selectedProject.contact_person.primary_email
                                  "
                                  class="d-flex align-center mb-1"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-email-outline</v-icon
                                  >
                                  <span class="text-truncate">{{
                                    selectedProject.contact_person.primary_email
                                  }}</span>
                                </div>
                                <div
                                  v-if="
                                    selectedProject.contact_person.primary_phone
                                  "
                                  class="d-flex align-center"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-phone-outline</v-icon
                                  >
                                  <span>{{
                                    selectedProject.contact_person.primary_phone
                                  }}</span>
                                </div>
                              </div>
                              <em v-else class="text-caption-1 grey--text"
                                >No contact person</em
                              >
                            </v-card>
                          </v-card>
                        </td>
                      </tr>

                      <!-- Quotation Info Card -->
                      <tr
                        v-if="
                          detail.expense_category == 3 && detail.quotation > 0
                        "
                      >
                        <td colspan="2" class="font-weight-medium py-1">
                          <v-card
                            class="pa-3 rounded-lg white left-border-purple shadow-sm mb-2"
                            outlined
                          >
                            <div
                              class="d-flex align-center justify-space-between mb-2 pb-1 border-bottom"
                            >
                              <div class="d-flex align-center">
                                <v-icon
                                  small
                                  color="purple darken-1"
                                  class="mr-2"
                                  >mdi-text-box-outline</v-icon
                                >
                                <span
                                  class="text-subtitle-2 font-weight-bold purple--text text--darken-2"
                                >
                                  Quotation Info
                                </span>
                              </div>
                              <v-chip
                                label
                                x-small
                                color="purple darken-1"
                                outlined
                                class="font-weight-bold"
                                v-if="
                                  selectedQuotation && selectedQuotation.barcode
                                "
                              >
                                {{ selectedQuotation.barcode }}
                              </v-chip>
                            </div>

                            <!-- Site Address -->
                            <v-card
                              flat
                              class="pa-2 rounded-lg grey lighten-5 border mb-2"
                            >
                              <div
                                class="text-caption-1 font-weight-bold orange--text text--darken-3 mb-1"
                              >
                                Site Location
                              </div>
                              <div
                                class="text-caption-1 grey--text text--darken-3"
                              >
                                <div>{{ leadAddress() }}</div>
                                <a
                                  v-if="leadAddress()"
                                  class="blue--text text--darken-1 text-caption-1 d-block mt-1"
                                  :href="
                                    'https://www.google.com/maps/search/?api=1&query=' +
                                    encodeURIComponent(leadAddress())
                                  "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style="text-decoration: none"
                                >
                                  <v-icon
                                    x-small
                                    color="blue darken-1"
                                    class="mr-1"
                                    >mdi-open-in-new</v-icon
                                  >
                                  View on Map
                                </a>
                              </div>
                            </v-card>

                            <!-- Contact Details -->
                            <v-card
                              flat
                              class="pa-2 rounded-lg grey lighten-5 border"
                            >
                              <div
                                class="text-caption-1 font-weight-bold green--text text--darken-2 mb-1"
                              >
                                Contact Details
                              </div>
                              <div
                                class="text-caption-1 grey--text text--darken-3"
                                v-if="selectedLead"
                              >
                                <div
                                  v-if="selectedLead.email"
                                  class="d-flex align-center mb-1"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-email-outline</v-icon
                                  >
                                  <span class="text-truncate">{{
                                    selectedLead.email
                                  }}</span>
                                </div>
                                <div
                                  v-if="selectedLead.phone"
                                  class="d-flex align-center"
                                >
                                  <v-icon
                                    x-small
                                    color="green darken-1"
                                    class="mr-1"
                                    >mdi-phone-outline</v-icon
                                  >
                                  <span>{{ selectedLead.phone }}</span>
                                </div>
                              </div>
                            </v-card>
                          </v-card>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Category & Budget Summary Card -->
                  <v-card
                    class="pa-3 mx-2 rounded-lg white left-border-red shadow-sm mt-0"
                    outlined
                  >
                    <div class="d-flex align-center mb-2 pb-1">
                      <v-icon small color="red darken-1" class="mr-2"
                        >mdi-calculator-variant-outline</v-icon
                      >
                      <span
                        class="font-size-15 font-weight-bold red--text text--darken-2"
                      >
                        Category Details
                      </span>
                    </div>

                    <table width="100%" class="text-caption-1">
                      <tbody>
                        <tr>
                          <td
                            class="grey--text text--darken-1 py-1 font-weight-medium"
                          >
                            Category
                          </td>
                          <td
                            class="text-right font-weight-bold grey--text text--darken-3 py-1"
                          >
                            {{ detail.claim_category || "—" }}
                          </td>
                        </tr>
                        <tr v-if="subcategoryList.length > 0">
                          <td
                            class="grey--text text--darken-1 py-1 font-weight-medium"
                          >
                            Sub-Category
                          </td>
                          <td
                            class="text-right font-weight-bold grey--text text--darken-3 py-1"
                          >
                            {{ detail.sub_category_name || "—" }}
                          </td>
                        </tr>

                        <tr>
                          <td
                            class="grey--text text--darken-1 py-1 font-weight-medium"
                          >
                            Total Budget
                          </td>
                          <td
                            class="text-right font-weight-bold red--text text--darken-2 py-1"
                          >
                            {{ detail.currency }}
                            {{ formatAmount(totalBudget) }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="grey--text text--darken-1 py-1 font-weight-medium"
                          >
                            Total Claims
                          </td>
                          <td
                            class="text-right font-weight-bold red--text text--darken-1 py-1"
                          >
                            {{ detail.currency }}
                            {{ formatAmount(totalClaims) }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="grey--text text--darken-1 py-1 font-weight-medium"
                          >
                            Amount
                          </td>
                          <td
                            class="text-right font-weight-bold grey--text text--darken-3 py-1"
                          >
                            {{ detail.currency }} {{ detail.amount || "0.00" }}
                          </td>
                        </tr>

                        <tr>
                          <td colspan="2">
                            <v-divider class="my-1"></v-divider>
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="py-1 font-size-15 text-capitalize font-weight-700"
                          >
                            Total Available
                          </td>
                          <td
                            class="text-right font-weight-bold green--text text--darken-2 font-size-15 py-1"
                          >
                            {{ detail.currency }}
                            {{ formatAmount(totalAvailable) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-card>
                </v-form>
              </perfect-scrollbar>
            </v-card>
          </v-col>
          <!-- Main Form Container -->
          <v-col cols="12" md="9" class="pl-md-2 pt-0">
            <v-layout class="d-block iv-custom-field">
              <v-container fluid class="pt-0 px-0">
                <v-card class="pa-2 rounded-lg mb-4 outlined elevation-1">
                  <v-btn-toggle
                    v-model="detail.expense_category"
                    mandatory
                    borderless
                    class="my-0 w-100 claim-tabs"
                    min-height="32"
                  >
                    <template v-for="(cat, index) in expenseCategories">
                      <v-btn
                        small
                        :key="`cat-btn-${index}`"
                        :value="cat.id"
                        class="flex-grow-1 font-weight-500 text-capitalize"
                        depressed
                        :style="getActiveCatStyle(cat)"
                        min-height="32"
                        :disabled="editId > 0 ? true : false"
                      >
                        {{ cat.name }}
                      </v-btn>
                    </template>
                  </v-btn-toggle>
                </v-card>

                <perfect-scrollbar
                  :options="{ suppressScrollX: true }"
                  class="scroll"
                  style="max-height: calc(100vh - 205px); position: relative"
                >
                  <v-container fluid class="py-0 px-1">
                    <v-row dense>
                      <v-col cols="12">
                        <!-- Claim Information Card -->
                        <v-card
                          flat
                          class="custom-grey-border remove-border-radius mb-4"
                        >
                          <v-card-title class="headline grey lighten-4 py-1">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                            >
                              Claim Information
                            </span>
                          </v-card-title>
                          <v-card-text class="pa-4">
                            <v-row dense>
                              <v-col cols="12" md="8">
                                <label
                                  class="font-size-16 font-weight-500 required mt-0 mb-2 d-block"
                                  for="title"
                                >
                                  Title
                                </label>
                                <TextField
                                  dense
                                  filled
                                  color="cyan"
                                  placeholder="Title"
                                  solo
                                  flat
                                  :counter="100"
                                  class="width-100"
                                  v-model.trim="detail.title"
                                  :rules="[
                                    validateRules.required(
                                      detail.title,
                                      'Title'
                                    ),
                                  ]"
                                ></TextField>
                              </v-col>
                              <v-col cols="12" md="4">
                                <label
                                  class="font-size-16 font-weight-500 required"
                                  >Claim Date</label
                                >
                                <DatePicker
                                  dense
                                  flat
                                  filled
                                  solo
                                  placeholder="DD-MM-YYYY"
                                  v-model="detail.expense_date"
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <label
                                  class="font-size-16 font-weight-500 required"
                                  >Employee</label
                                >
                                <v-autocomplete
                                  :menu-props="{ auto: false, offsetY: true }"
                                  dense
                                  flat
                                  filled
                                  solo
                                  v-model="detail.engineer"
                                  :items="employeesList"
                                  placeholder="Select employee"
                                  item-text="name"
                                  item-value="id"
                                  v-on:change="employeeDetails(true)"
                                >
                                  <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                      <v-list-item-title>{{
                                        item.name
                                      }}</v-list-item-title>
                                      <v-list-item-subtitle
                                        v-if="item.designation"
                                      >
                                        <v-chip
                                          class="ml-1"
                                          small
                                          label
                                          outlined
                                          color="green"
                                        >
                                          {{ item.designation }}
                                        </v-chip>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                      <v-chip small label outlined color="blue">
                                        {{ item.role }}
                                      </v-chip>
                                    </v-list-item-action>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <template v-if="detail.expense_category == 4">
                                <v-col cols="12" md="4">
                                  <label class="font-size-16 font-weight-500"
                                    >Customer</label
                                  >
                                  <v-autocomplete
                                    id="filter-customer"
                                    dense
                                    v-model="detail.customer"
                                    filled
                                    :search-input.sync="customer_search"
                                    :items="customerList"
                                    hide-details
                                    :disabled="customerList.length == 0"
                                    :loading="customer_loading"
                                    placeholder="Select Customer"
                                    v-on:update:search-input="customerFilter"
                                    v-on:click.native="refreshCustomerListOnOpen"
                                    solo
                                    flat
                                    item-value="id"
                                    clearable
                                    item-text="display_name"
                                    @change="
                                      fetchVisits();
                                      fetchLeads();
                                    "
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          v-html="'No Customer(s) Found.'"
                                        ></v-list-item-title>
                                      </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                      <v-list-item-avatar class="mr-1">
                                        <v-img
                                          :lazy-src="$defaultProfileImage"
                                          :src="$assetAPIURL(item.profile_logo)"
                                          aspect-ratio="1"
                                          class="margin-auto"
                                          transition="fade-transition"
                                        ></v-img>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-title
                                          class="text-capitalize font-weight-500 font-size-16"
                                          >{{
                                            item.display_name
                                          }}</v-list-item-title
                                        >
                                        <v-list-item-title
                                          class="text-capitalize font-weight-500 font-size-16"
                                          >{{ item.company_name }}
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <v-list-item-action
                                        v-if="item.default_person"
                                        class="align-self-center"
                                      >
                                        <v-list-item-subtitle
                                          class="text-lowercase pb-2 font-weight-500 font-size-14 hover-effect"
                                          ><v-icon
                                            small
                                            class="mr-1"
                                            color="grey darken-1"
                                            >mdi-email-outline</v-icon
                                          >{{
                                            item.default_person.primary_email
                                          }}</v-list-item-subtitle
                                        >
                                        <v-list-item-subtitle
                                          class="text-lowercase font-weight-500 font-size-14 hover-effect"
                                          ><v-icon
                                            small
                                            class="mr-1"
                                            color="grey darken-1"
                                            >mdi-phone-outline</v-icon
                                          >{{
                                            item.default_person.primary_phone
                                          }}</v-list-item-subtitle
                                        >
                                      </v-list-item-action>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                  v-if="
                                    !selectedEmployee ||
                                    selectedEmployee.role_id != 2
                                  "
                                >
                                  <label class="font-size-16 font-weight-500"
                                    >Lead</label
                                  >
                                  <v-autocomplete
                                    :menu-props="{ auto: false, offsetY: true }"
                                    dense
                                    flat
                                    filled
                                    solo
                                    v-model="detail.lead_id"
                                    :items="leadsListing"
                                    placeholder="Select Lead"
                                    item-text="lead_name"
                                    item-value="id"
                                    @change="onLeadChange"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                  v-if="
                                    !selectedEmployee ||
                                    selectedEmployee.role_id != 5
                                  "
                                >
                                  <label
                                    class="font-size-16 font-weight-500 mb-2 d-block"
                                    for="select_entity"
                                    >Visit</label
                                  >
                                  <v-autocomplete
                                    :menu-props="{ auto: false, offsetY: true }"
                                    hide-details
                                    v-model="detail.visit"
                                    :items="visits"
                                    :loading="pageLoading"
                                    dense
                                    flat
                                    filled
                                    placeholder="Select Visit"
                                    item-color="cyan"
                                    color="cyan"
                                    solo
                                    item-value="id"
                                    item-text="visit_title"
                                    @change="onVisitChange"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Visit(s) Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                      <v-list-item-content>
                                        <v-list-item-subtitle
                                          class="grey--text ml-2"
                                        >
                                          <v-chip
                                            label
                                            small
                                            outlined
                                            color="blue"
                                            >{{ item.barcode }}</v-chip
                                          >
                                          — {{ item.visit_title }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </template>
                              <template
                                v-else-if="detail.expense_category == 3"
                              >
                                <v-col cols="12" md="4">
                                  <label class="font-size-16 font-weight-500"
                                    >Customer</label
                                  >
                                  <v-autocomplete
                                    id="filter-customer"
                                    dense
                                    v-model="detail.customer"
                                    filled
                                    :search-input.sync="customer_search"
                                    :items="customerList"
                                    hide-details
                                    :disabled="customerList.length == 0"
                                    :loading="customer_loading"
                                    placeholder="Select Customer"
                                    v-on:update:search-input="customerFilter"
                                    v-on:click.native="refreshCustomerListOnOpen"
                                    solo
                                    flat
                                    item-value="id"
                                    clearable
                                    item-text="display_name"
                                    @change="
                                      fetchVisits();
                                      fetchQuotations();
                                      fetchProjects();
                                      fetchLeads();
                                    "
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          v-html="'No Customer(s) Found.'"
                                        ></v-list-item-title>
                                      </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                      <v-list-item-avatar class="mr-1">
                                        <v-img
                                          :lazy-src="$defaultProfileImage"
                                          :src="$assetAPIURL(item.profile_logo)"
                                          aspect-ratio="1"
                                          class="margin-auto"
                                          transition="fade-transition"
                                        ></v-img>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-title
                                          class="text-capitalize font-weight-500 font-size-16"
                                          >{{
                                            item.display_name
                                          }}</v-list-item-title
                                        >
                                        <v-list-item-title
                                          class="text-capitalize font-weight-500 font-size-16"
                                          >{{ item.company_name }}
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <v-list-item-action
                                        v-if="item.default_person"
                                        class="align-self-center"
                                      >
                                        <v-list-item-subtitle
                                          class="text-lowercase pb-2 font-weight-500 font-size-14 hover-effect"
                                          ><v-icon
                                            small
                                            class="mr-1"
                                            color="grey darken-1"
                                            >mdi-email-outline</v-icon
                                          >{{
                                            item.default_person.primary_email
                                          }}</v-list-item-subtitle
                                        >
                                        <v-list-item-subtitle
                                          class="text-lowercase font-weight-500 font-size-14 hover-effect"
                                          ><v-icon
                                            small
                                            class="mr-1"
                                            color="grey darken-1"
                                            >mdi-phone-outline</v-icon
                                          >{{
                                            item.default_person.primary_phone
                                          }}</v-list-item-subtitle
                                        >
                                      </v-list-item-action>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <label
                                    class="font-size-16 font-weight-500 mb-2 d-block"
                                    for="select_entity"
                                    >Visit</label
                                  >
                                  <v-autocomplete
                                    :menu-props="{ auto: false, offsetY: true }"
                                    hide-details
                                    v-model="detail.visit"
                                    :items="visits"
                                    :loading="pageLoading"
                                    dense
                                    flat
                                    filled
                                    placeholder="Select Visit"
                                    item-color="cyan"
                                    color="cyan"
                                    solo
                                    item-value="id"
                                    item-text="visit_title"
                                    @change="onVisitChange"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Visit(s) Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                      <v-list-item-content>
                                        <v-list-item-subtitle
                                          class="grey--text ml-2"
                                        >
                                          <v-chip
                                            label
                                            small
                                            outlined
                                            color="blue"
                                            >{{ item.barcode }}</v-chip
                                          >
                                          — {{ item.visit_title }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <label
                                    class="font-size-16 font-weight-500 mb-2 d-block"
                                  >
                                    Project
                                    <span
                                      v-if="
                                        !detail.project && !detail.quotation
                                      "
                                      class="red--text"
                                      >*</span
                                    >
                                  </label>
                                  <v-autocomplete
                                    ref="projectField"
                                    :menu-props="{ auto: false, offsetY: true }"
                                    :hide-details="'auto'"
                                    v-model="detail.project"
                                    :items="projects"
                                    :loading="pageLoading"
                                    dense
                                    flat
                                    filled
                                    placeholder="Select Project"
                                    item-color="cyan"
                                    color="cyan"
                                    solo
                                    item-value="id"
                                    item-text="project_name"
                                    :rules="[
                                      () =>
                                        detail.quotation
                                          ? true
                                          : projectOrQuotationRule(),
                                    ]"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Project(s)
                                          Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                      <v-list-item-content>
                                        <v-list-item-subtitle
                                          class="grey--text ml-2"
                                        >
                                          <v-chip
                                            label
                                            small
                                            outlined
                                            color="blue"
                                            >{{ item.barcode }}</v-chip
                                          >
                                          — {{ item.project_name }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <label
                                    class="font-size-16 font-weight-500 mb-2 d-block"
                                  >
                                    Quotation
                                    <span
                                      v-if="
                                        !detail.project && !detail.quotation
                                      "
                                      class="red--text"
                                      >*</span
                                    >
                                  </label>
                                  <v-autocomplete
                                    ref="quotationField"
                                    :menu-props="{ auto: false, offsetY: true }"
                                    :hide-details="'auto'"
                                    v-model="detail.quotation"
                                    :items="quotations"
                                    :loading="pageLoading"
                                    dense
                                    flat
                                    filled
                                    placeholder="Select Quotation"
                                    item-color="cyan"
                                    color="cyan"
                                    solo
                                    item-value="id"
                                    item-text="quotation_title"
                                    :rules="[
                                      () =>
                                        detail.project
                                          ? true
                                          : projectOrQuotationRule(),
                                    ]"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Quotation(s)
                                          Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                      <v-list-item-content>
                                        <v-list-item-subtitle
                                          class="grey--text ml-2"
                                        >
                                          <v-chip
                                            label
                                            small
                                            outlined
                                            color="blue"
                                            >{{ item.barcode }}</v-chip
                                          >
                                          — {{ item.quotation_title }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </template>
                              <v-col cols="12" md="4">
                                <label
                                  :class="`font-weight-500 font-size-16 ${
                                    detail.expense_category == 2
                                      ? 'required'
                                      : ''
                                  }`"
                                  >SBU</label
                                >
                                <v-select
                                  v-model.trim="detail.sbu"
                                  :items="sbuList"
                                  :disabled="pageLoading"
                                  :rules="
                                    detail.expense_category == 2
                                      ? [
                                          validateRules.required(
                                            detail.sbu,
                                            'SBU'
                                          ),
                                        ]
                                      : []
                                  "
                                  dense
                                  filled
                                  flat
                                  return-object
                                  solo
                                  item-text="text"
                                  item-value="value"
                                  append-outer-icon="mdi-cog"
                                  @click:append-outer="openSbuDialog"
                                  hide-details
                                  placeholder="Select SBU"
                                  @change="manageSbuData"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <!-- Payment Details Card -->
                        <v-card
                          flat
                          class="custom-grey-border remove-border-radius mb-4"
                        >
                          <v-card-title class="headline grey lighten-4 py-1">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                            >
                              Payment Details
                            </span>
                          </v-card-title>
                          <v-card-text class="pa-4">
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="4"
                                v-if="subcategoryList.length > 0"
                              >
                                <label class="font-size-16 font-weight-500"
                                  >Sub-category</label
                                >
                                <v-autocomplete
                                  :menu-props="{ auto: false, offsetY: true }"
                                  hide-details
                                  v-model="detail.sub_category"
                                  :items="subcategoryList"
                                  dense
                                  flat
                                  filled
                                  placeholder="Claim Sub Category"
                                  item-color="cyan"
                                  color="cyan"
                                  solo
                                  item-value="id"
                                  item-text="name"
                                  v-on:change="manageSubCategory"
                                >
                                  <template v-slot:no-data>
                                    <v-list-item>
                                      <v-list-item-title
                                        >No sub Categories
                                        Found.</v-list-item-title
                                      >
                                    </v-list-item>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="4">
                                <label
                                  class="font-size-16 font-weight-500 required mb-2 d-block"
                                  for="payment_mode"
                                >
                                  Payment Mode
                                </label>
                                <v-autocomplete
                                  :menu-props="{ auto: false, offsetY: true }"
                                  hide-details
                                  v-model="detail.payment_mode"
                                  :items="paymentModes"
                                  dense
                                  flat
                                  filled
                                  placeholder="Payment Mode"
                                  item-color="cyan"
                                  color="cyan"
                                  solo
                                  item-value="id"
                                  item-text="name"
                                  :rules="[
                                    validateRules.required(
                                      detail.payment_mode,
                                      'Payment Mode'
                                    ),
                                  ]"
                                >
                                  <template v-slot:no-data>
                                    <v-list-item>
                                      <v-list-item-title
                                        >No Payment Modes
                                        Found.</v-list-item-title
                                      >
                                    </v-list-item>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="4">
                                <label
                                  class="font-size-16 font-weight-500 required"
                                  >Amount</label
                                >
                                <div class="d-flex align-center">
                                  <v-text-field
                                    style="max-width: 100px"
                                    dense
                                    flat
                                    filled
                                    solo
                                    v-model="detail.currency"
                                    readonly
                                    placeholder="SGD"
                                    class="mr-2"
                                  />
                                  <v-text-field
                                    dense
                                    flat
                                    filled
                                    solo
                                    v-model="detail.amount"
                                    placeholder="0.00"
                                    type="number"
                                    v-on:keyup="() => manageAmount()"
                                    @keypress="validateNumber($event)"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="12" md="4">
                                <label class="font-size-16 font-weight-500"
                                  >Vendor Name</label
                                >
                                <TextField
                                  dense
                                  flat
                                  filled
                                  solo
                                  :maxlength="50"
                                  :counter="50"
                                  placeholder="Enter Vendor Name"
                                  v-model="detail.vendor_name"
                                />
                              </v-col>

                              <v-col cols="12" md="4">
                                <label class="font-size-16 font-weight-500"
                                  >Receipt Number</label
                                >
                                <TextField
                                  dense
                                  flat
                                  filled
                                  :maxlength="20"
                                  :counter="20"
                                  solo
                                  placeholder="Enter Receipt Number"
                                  v-model="detail.receipt_number"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <!-- Description Card -->
                        <v-card
                          flat
                          class="custom-grey-border remove-border-radius mb-4"
                        >
                          <v-card-title class="headline grey lighten-4 py-1">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                            >
                              Description
                            </span>
                          </v-card-title>
                          <v-card-text class="pa-4">
                            <v-row dense>
                              <v-col cols="12">
                                <v-textarea
                                  v-model="detail.note"
                                  auto-grow
                                  dense
                                  filled
                                  color="cyan"
                                  placeholder="Description"
                                  solo
                                  flat
                                  row-height="15"
                                  v-on:keypress="(e) => manageNoteLimit(e)"
                                  v-on:paste="(e) => onNotePaste(e)"
                                  :maxlength="200"
                                ></v-textarea>
                                <div
                                  class="text-right text-caption-1 mt-1 grey--text"
                                >
                                  {{ detail.note ? detail.note.length : 0 }}/200
                                </div>
                                
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <!-- Attachment Card -->
                        <v-card
                          flat
                          class="custom-grey-border remove-border-radius mb-4"
                        >
                          <v-card-title class="headline grey lighten-4 py-1">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                            >
                              Attachment<span
                                v-if="isAttachmentRequired"
                                class="required"
                              ></span>
                            </span>
                          </v-card-title>
                          <v-card-text class="pa-4">
                            <v-row dense>
                              <v-col cols="12">
                                <file-upload
                                  v-model="detail.attachments"
                                  :maxLimit="5"
                                  @delete:file="handleDeletedAttachment"
                                >
                                </file-upload>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </perfect-scrollbar>
              </v-container>
            </v-layout>
          </v-col>
        </v-row>
      </template>
    </CreateUpdateTemplate>
    <ManageMotorSettings
      :mDialog="manageSbuDialog"
      :settings="sbuList"
      title="SBU"
      endpoint="setting/sbu"
      value="sbu"
      @close-dialog="manageSbuDialog = false"
      @get-settings="getSbuList"
    />
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import SystemGenerateId from "@/view/pages/partials/SystemGenerateId.vue";
// import BasicDetails from "@/view/pages/claim/create-or-update/Basic-Details.vue";
import { POST, GET, PUT, QUERY } from "@/core/services/store/request.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ErrorEventBus,
  SuccessEventBus,
  InitializeError,
} from "@/core/lib/message.lib";
import DatePicker from "@/view/components/DatePicker.vue";
import ManageMotorSettings from "@/view/pages/partials/Manage-Motor-Settings.vue";
import FileUpload from "@/view/components/app-component/FileInput";
import { filter, find, join } from "lodash";
export default {
  name: "create-claim",
  mixins: [CommonMixin, ValidationMixin],

  data() {
    return {
      searchTimeout: null,
      customer_search: null,
      customer_loading: false,
      customerRequestId: 0,
      subcategoryList: [],
      leadsListing: [],
      leadRequestId: 0,
      leadRequestKey: null,
      paymentModes: [],
      claimCategories: [],
      customerList: [],
      sbuList: [],
      employees: [],
      visits: [],
      quotations: [],
      formValid: true,
      formLoading: false,
      selectedEmployee: {},
      pageLoading: false,
      manageSbuDialog: false,
      routePreventDialog: false,
      totalAllowAmount: 0,
      editEmployee: 0,
      expenseCategories: [],
      barcode: null,
      editId: null,
      isEditMode: false,
      opportunitys: [],
      projects: [],
      totalBudget: 0,
      totalClaims: 0,
      totalAvailable: 0,
      deletedAttachments: [],
      is_attachment_mandatory: false,
      detail: {
        type: "visit",
        lead: null,
        lead_name: null,
        customer: null,
        visit: null,
        project: null,
        quotation: null,
        opportunity: null,
        title: "",
        reference: "",
        company_name: "",
        engineer: null,
        vendor_name: "",
        currency: "SGD",
        expense_category: 0,
        sub_category: null,
        sub_category_name: null,
        payment_mode: null,
        amount: null,
        receipt_number: null,
        expense_date: new Date().toISOString().substr(0, 10),
        note: "",
        sbu_name: "",
        sbu: 0,
        attachments: [],
      },
    };
  },

  components: {
    CreateUpdateTemplate,
    SystemGenerateId,
    // BasicDetails,
    DatePicker,
    ManageMotorSettings,
    FileUpload,
  },

  methods: {
    onLeadChange(val) {
      this.detail.lead_id = val;

      this.detail.visit = null;
    },
    onVisitChange(val) {
      this.detail.visit = val;

      if (val && !this.detail.type) {
        this.detail.type = "visit";
      } else if (!val && this.detail.type === "visit") {
        this.detail.type = null;
      }
      if (this.detail.expense_category == 4) {
        this.detail.lead_id = null;
      }
    },
    projectOrQuotationRule() {
      if (!this.detail.project && !this.detail.quotation) {
        return "Either Project or Quotation is required";
      }
      return true;
    },
    customerFilter() {
      clearTimeout(this.searchTimeout);

      if (!this.customer_search) {
        return false;
      }
      if (this.detail.customer) {
        let selectedCust = find(
          this.customerList,
          (row) => row.id == this.detail.customer
        );
        if (selectedCust) {
          let selected = selectedCust?.display_name;
          if (selected?.toUpperCase() == this.customer_search?.toUpperCase()) {
            return false;
          }
        }
      }

      this.searchTimeout = setTimeout(() => {
        this.getCustomers();
      }, 1000);
    },
    refreshCustomerListOnOpen() {
      if (this.customer_loading && !this.customer_search) {
        return;
      }

      const selectedCustomer = find(
        this.customerList,
        (row) => row.id == this.detail.customer
      );
      const selectedName = selectedCustomer?.display_name || "";
      const currentSearch = String(this.customer_search || "");

      if (
        !currentSearch ||
        (selectedName &&
          selectedName.toUpperCase() === currentSearch.toUpperCase())
      ) {
        clearTimeout(this.searchTimeout);
        this.customer_search = null;
        this.getCustomers(null, selectedCustomer);
      }
    },
    getCustomers(search = this.customer_search, customerToPreserve = null) {
      const requestId = ++this.customerRequestId;
      const selectedCustomer =
        customerToPreserve ||
        find(
          this.customerList,
          (row) => row.id == this.detail.customer
        );
      this.customer_loading = true;
      this.$store
        .dispatch(QUERY, {
          url: "filter-customer",
          data: { search: search || null },
        })
        .then(({ data }) => {
          if (requestId !== this.customerRequestId) return;
          const customers = data.map((row) => {
            row.id = Number(row.id);
            return row;
          });

          if (
            selectedCustomer &&
            selectedCustomer.id == this.detail.customer &&
            !find(customers, (row) => row.id == selectedCustomer.id)
          ) {
            customers.unshift(selectedCustomer);
          }

          this.customerList = customers;
        })
        .catch((error) => {
          if (requestId !== this.customerRequestId) return;
          this.customerList = [];
          this.logError(error);
        })
        .finally(() => {
          if (requestId === this.customerRequestId) {
            this.customer_loading = false;
          }
        });
    },
    leadAddress() {
      if (this.selectedLead) {
        let leadAddress = [];
        if (this.selectedLead.unit_no) {
          leadAddress.push(this.selectedLead.unit_no);
        }
        if (this.selectedLead.address_line_1) {
          leadAddress.push(this.selectedLead.address_line_1);
        }
        if (this.selectedLead.address_line_2) {
          leadAddress.push(this.selectedLead.address_line_2);
        }
        if (this.selectedLead.postal_code) {
          leadAddress.push(this.selectedLead.postal_code);
        }
        if (this.selectedLead.country) {
          leadAddress.push(this.selectedLead.country);
        }
        return join(leadAddress, ", ");
      }
      return null;
    },
    manageSubCategory(data) {
      let subCatData = find(this.subcategoryList, (row) => row.id == data);
      this.detail.sub_category_name = subCatData.name;
    },
    manageAmount() {
      const currentAmount = parseFloat(this.detail.amount) || 0;
      const remainingLimit = this.totalBudget - this.totalClaims;
      this.totalAllowAmount = remainingLimit;
      this.totalAvailable = remainingLimit - currentAmount;
    },
    manageCategoryData(selectedCategory) {
      let totalBudget = 0;
      let totalClaims = 0;
      if (selectedCategory) {
        this.detail.claim_category = selectedCategory
          ? selectedCategory.name
          : "";
        totalBudget = parseFloat(selectedCategory.max_amount) || 0;
        totalClaims = selectedCategory.total_claimed
          ? parseFloat(selectedCategory.total_claimed)
          : 0;
      }
      this.totalBudget = totalBudget;
      this.totalClaims = totalClaims;
      this.manageAmount();
    },
    getClaimDetails() {
      if (this.detail.expense_category > 0 && this.detail.engineer > 0) {
        let data = {
          employee: this.detail.engineer,
          category: this.detail.expense_category,
          claim_date: this.detail.expense_date,
        };
        if (
          this.editId &&
          this.editId > 0 &&
          this.editEmployee == this.detail.engineer
        ) {
          data.claim_id = this.editId;
        }
        const _this = this;
        this.pageLoading = true;
        _this.$store
          .dispatch(QUERY, {
            url: "claims/category-details",
            data,
          })
          .then(({ data }) => {
            this.pageLoading = false;
            if (data) {
              this.manageCategoryData(data);
            }
          })
          .catch((error) => {
            _this.logError(error);
          });
      }
    },
    manageLimit(e) {
      if (this.textareainput && this.textareainput.length > 199) {
        e.preventDefault();
      }
    },
    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.textareainput;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.textareainput = trimValue;
        e.preventDefault();
      }
    },
    limitDecimal(event) {
      const value = event.target.value;
      const key = event.key;

      if (
        ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(key)
      )
        return;

      if (!/[0-9.]/.test(key)) {
        event.preventDefault();
        return;
      }

      if (key === "." && value.includes(".")) {
        event.preventDefault();
        return;
      }

      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        const decimals = value.substring(decimalIndex + 1);
        if (
          decimals.length >= 2 &&
          event.target.selectionStart > decimalIndex
        ) {
          event.preventDefault();
        }
      }
    },
    validateNumber($event) {
      this.limitDecimal($event, this.detail.amount);
      this.limitMaxLength($event, this.detail.amount, 12);
      this.limitMaxNumber($event, this.totalAllowAmount);
    },
    async fetchOptions() {
      try {
        this.pageLoading = true;
        const { data } = await this.$store.dispatch(GET, {
          url: "claims/options",
        });

        if (data && data.payment_modes) {
          this.paymentModes = data.payment_modes;
        }
        if (data && data.currencies) {
          this.currencies = data.currencies;
        }
        if (data && data.claim_categories) {
          this.claimCategories = data.claim_categories;
        }
      } catch (error) {
        this.logError(error);
      } finally {
        this.pageLoading = false;
      }
    },
    manageSbuData(data) {
      if (data) {
        this.detail.sbu = data.value;
        this.detail.sbu_name = data.text;
      }
    },
    openSbuDialog() {
      if (console) console.log("Gear clicked for SBU");
      this.manageSbuDialog = true;
    },
    getSbuList() {
      this.$store.dispatch(GET, { url: "setting/sbu" }).then(({ data }) => {
        this.sbuList = data.filter((item) => item.activated);
      });
    },
    async fetchEmployees() {
      this.pageLoading = true;
      try {
        const { data } = await this.$store.dispatch(GET, {
          url: "user-dropdown",
        });

        if (data && Array.isArray(data)) {
          this.employees = data.map((engineer) => ({
            id: engineer.id,
            name:
              engineer.full_name || engineer.display_name || "Unnamed Employee",
            designation: engineer.designation?.text || "",
            primary_email: engineer.user_email || null,
            role: engineer.role?.name || "",
            role_id: engineer.role?.id || 0,
            primary_phone: engineer.phone_number || null,
          }));
        } else {
          this.employees = [];
        }
      } catch (error) {
        this.logError(error);
        this.employees = [];
      } finally {
        this.pageLoading = false;
      }
    },
    async fetchLeads() {
      if (
        !(
          this.detail.engineer > 0 &&
          this.detail.expense_category == 4 &&
          this.selectedEmployee?.role_id != 2
        )
      ) {
        this.leadRequestId += 1;
        this.leadRequestKey = null;
        this.leadsListing = [];
        return;
      }

      const requestData = { user: this.detail.engineer };
      const requestKey = String(requestData.user);
      if (this.leadRequestKey === requestKey) {
        return;
      }

      const requestId = ++this.leadRequestId;
      this.leadRequestKey = requestKey;
      this.pageLoading = true;

      try {
        const { data } = await this.$store.dispatch(QUERY, {
          url: "lead-dropdown",
          data: requestData,
        });

        if (requestId !== this.leadRequestId) {
          return;
        }

        if (data && Array.isArray(data)) {
          this.leadsListing = data.map((lead) => ({
            id: lead.id,
            phone: lead.property_primary_phone,
            email: lead.property_primary_email,
            address_line_1: lead.address_line_1,
            address_line_2: lead.address_line_2,
            country: lead.country,
            barcode: lead.barcode,
            name: lead.lead_name,
            postal_code: lead.postal_code,
            unit_no: lead.unit_no,
            lead_name:
              lead.barcode + " - " + (lead.lead_name || "Unnamed Lead"),
          }));
        } else {
          this.leadsListing = [];
        }
      } catch (error) {
        if (requestId === this.leadRequestId) {
          this.leadRequestKey = null;
          this.logError(error);
          this.leadsListing = [];
        }
      } finally {
        if (requestId === this.leadRequestId) {
          this.pageLoading = false;
        }
      }
    },
    async fetchVisits() {
      if (
        this.detail.engineer > 0 &&
        (this.detail.expense_category == 3 || this.detail.expense_category == 4)
      ) {
        this.pageLoading = true;
        let requestData = { user: this.detail.engineer };
        if (this.detail.customer && this.detail.customer > 0) {
          requestData.customer = this.detail.customer;
        }
        try {
          const { data } = await this.$store.dispatch(QUERY, {
            url: "visit-dropdown",
            data: requestData,
          });

          if (data) {
            this.visits = data.map((visit) => ({
              id: visit.id,
              barcode: visit.barcode,
              title: visit.title,
              visit_title: `${visit.title} (${
                visit.customer_company_name || "No Company"
              })`,
              site_location: visit.property_address || null,
              customer_id: visit.customer_id,
              project_details:
                visit.project > 0
                  ? {
                      project_barcode: visit.project_barcode,
                      project_name: visit.project_name,
                      project_pic: visit.project_pic,
                    }
                  : null,
              quote_details:
                visit.quotation > 0
                  ? {
                      quote_barcode: visit.quote_barcode,
                      quote_title: visit.quote_title,
                      quote_pic: visit.quote_pic,
                    }
                  : null,
              contact_person:
                visit.property_display_name ||
                visit.property_primary_email ||
                visit.property_primary_phone
                  ? {
                      display_name:
                        visit.property_display_name || "Contact Person",
                      name: visit.property_display_name || "Contact Person",
                      primary_email: visit.property_primary_email || null,
                      primary_phone: visit.property_primary_phone || null,
                    }
                  : null,
            }));
          } else {
            this.visits = [];
          }
        } catch (error) {
          this.logError(error);
          this.visits = [];
        } finally {
          this.pageLoading = false;
        }
      }
    },
    async fetchQuotations() {
      if (!this.detail.engineer && !this.detail.customer) {
        this.quotations = [];
        return;
      }

      if (this.detail.engineer > 0 && this.detail.expense_category == 3) {
        this.pageLoading = true;

        let requestData = { user: this.detail.engineer };

        if (this.detail.customer && this.detail.customer > 0) {
          requestData.customer = this.detail.customer;
        }

        try {
          const { data } = await this.$store.dispatch(QUERY, {
            url: "quotation-dropdown",
            data: requestData,
          });

          if (data) {
            this.quotations = data.map((q) => ({
              id: q.id,
              barcode: q.barcode,
              job_title: q.job_title,
              quotation_title: `${q.job_title} (${
                q.customer_company_name || "No Company"
              })`,
              site_location: q.quotation_site_location,

              customer_id: q.customer_id,
              sales_person: q.sales_person || null,
              contact_person:
                q.property_display_name ||
                q.property_primary_email ||
                q.property_primary_phone
                  ? {
                      display_name: q.property_display_name || "Contact Person",
                      name: q.property_display_name || "Contact Person",
                      primary_email: q.property_primary_email || null,
                      primary_phone: q.property_primary_phone || null,
                    }
                  : null,
            }));
          } else {
            this.quotations = [];
          }
        } catch (error) {
          this.logError(error);
          this.quotations = [];
        } finally {
          this.pageLoading = false;
        }
      }
    },
    async fetchProjects() {
      if (!this.detail.engineer && !this.detail.customer) {
        this.projects = [];
        return;
      }
      if (this.detail.engineer > 0 && this.detail.expense_category == 3) {
        this.pageLoading = true;

        let requestData = {};

        if (this.detail.engineer > 0) {
          requestData.user = this.detail.engineer;
        }

        if (this.detail.customer > 0) {
          requestData.customer = this.detail.customer;
        }

        try {
          const { data } = await this.$store.dispatch(QUERY, {
            url: "project-dropdown",
            data: requestData,
          });

          if (data) {
            this.projects = data.map((p) => ({
              id: p.id,
              barcode: p.barcode,
              project_name: p.project_name || p.name,

              site_location: p.project_property_address || null,

              project_title: `${p.project_name || p.name} (${
                p.customer_company_name || "No Company"
              })`,

              customer_id: p.customer_id,
              project_pic: p.project_pic || null,
              contact_person:
                p.contact_person_name ||
                p.contact_person_email ||
                p.contact_person_phone
                  ? {
                      display_name: p.contact_person_name || "Contact Person",
                      name: p.contact_person_name || "Contact Person",
                      primary_email: p.contact_person_email || null,
                      primary_phone: p.contact_person_phone || null,
                    }
                  : null,
            }));
          } else {
            this.projects = [];
          }
        } catch (error) {
          this.logError(error);
          this.projects = [];
        } finally {
          this.pageLoading = false;
        }
      }
    },
    async fetchCustomers() {
      this.pageLoading = true;
      try {
        const { data } = await this.$store.dispatch(GET, {
          url: "filter-customer",
        });
        if (data) {
          this.customerList = data.map((row) => {
            row.id = Number(row.id);
            return row;
          });
        }
      } catch (error) {
        this.logError(error);
      } finally {
        this.pageLoading = false;
      }
    },
    getActiveCatStyle(cat) {
      if (this.detail.expense_category == cat.id) {
        return {
          color: "#ffffff !important",
          background: `${cat.color} !important`,
        };
      }
      return {};
    },
    handleDeletedAttachment(file) {
      if (file.id) {
        this.deletedAttachments.push(file.id);
      }
    },
    employeeDetails(resetRelated = false) {
      if (resetRelated) {
        const hasRelatedSelection = [
          this.detail.visit,
          this.detail.lead_id,
          this.detail.project,
          this.detail.quotation,
          this.detail.opportunity,
        ].some((value) => Number(value) > 0);

        this.detail.visit = null;
        this.detail.lead_id = null;
        this.detail.project = null;
        this.detail.quotation = null;
        this.detail.opportunity = null;
        this.visits = [];
        this.leadsListing = [];
        this.projects = [];
        this.quotations = [];

        if (hasRelatedSelection) {
          this.detail.type = null;
        }
      }

      if (this.detail.engineer) {
        // this.detail.visit = null;
        // this.detail.lead_id = null;

        this.selectedEmployee = this.employees.find(
          (emp) => Number(emp.id) === Number(this.detail.engineer)
        ) || {};
        this.getClaimDetails();
        this.fetchVisits();
        this.fetchQuotations();
        this.fetchProjects();
        this.fetchLeads();
      } else {
        this.selectedEmployee = {};
      }
    },
    async initEditMode() {
      this.fetchCategories();
      this.getCustomers();
      const employeeRequest = this.fetchEmployees();
      this.fetchOptions();
      this.getSbuList();
      const editId = this.$route.query.edit;
      if (editId) {
        this.isEditMode = true;
        this.editId = editId;
        await employeeRequest;
        await this.fetchClaimData(editId);
      }
    },
    fetchCategories() {
      const _this = this;
      this.pageLoading = true;
      _this.$store
        .dispatch(GET, { url: "claims/category-list" })
        .then(({ data }) => {
          this.pageLoading = false;
          if (data) {
            this.expenseCategories = data;
          }
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    fetchClaimData(claimId) {
      const _this = this;
      this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: `claims/${claimId}`,
        })
        .then(({ data }) => {
          this.pageLoading = false;
          this.barcode = data.barcode;
          let claimAttachments = [];
          if (data.documents && data.documents.length > 0) {
            claimAttachments = data.documents;
          }
          let claim_category = data.claim_category;
          this.editEmployee = Number(data.engineer);

          this.detail = {
            ...this.detail,
            title: data.title || "",
            reference: data.reference || "",
            customer:
              data.customer && data.customer.id
                ? Number(data.customer.id)
                : Number(data.customer) || 0,
            currency: "SGD",
            visit: data.visit || 0,
            lead_id: data.lead && data.lead.id ? String(data.lead.id) : "0",
            project: data.project || 0,
            quotation: data.quotation || null,
            expense_category: data.expense_category || "",
            claim_category: claim_category,
            sub_category: data.claim_subcategory_id || 0,
            sub_category_name: data.claim_subcategory || null,
            sbu: Number(data.sbu) || 0,
            sbu_name: data.sbu_name || null,
            payment_mode: data.payment_mode || "",
            vendor_name: data.vendor_name || "",
            receipt_number: data.receipt_number || "",
            amount: data.amount || "",
            expense_date: data.expense_date,
            note: data.note || "",
            attachments: claimAttachments,
            type: data.claim_type || data.type || "visit",
            engineer: Number(data.engineer) || null,
          };

          this.employeeDetails();
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    formatAmount(amount) {
      return (amount || 0).toFixed(2);
    },
    async onSubmit(saveType) {
      const formErrors = this.validateForm(this.$refs.createQuotationForm);

      console.log({ formErrors });

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (!this.formValid) return;
      if (!this.isFormValid) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Please fill all required fields")
        );
        return;
      }

      this.formLoading = true;
      try {
        const submitData = {
          amount: this.detail.amount,
          attachments: this.detail.attachments || [],

          claim_category: this.detail.claim_category,
          type: this.detail.type,
          title: this.detail.title,
          expense_date: this.detail.expense_date,
          expense_category: this.detail.expense_category,
          sub_category: this.detail.sub_category,
          sub_category_name: this.detail.sub_category_name,
          payment_mode: this.detail.payment_mode,
          vendor_name: this.detail.vendor_name || "",
          receipt_number: this.detail.receipt_number || "",
          currency: 1,
          note: this.detail.note || "",
          engineer: this.detail.engineer,
          sbu_name: this.detail.sbu_name,
          sbu: this.detail.sbu,
          lead: this.detail.lead_id,
          save_type: saveType,
        };
        submitData.deleted_attachments = this.deletedAttachments;
        if (saveType === "approved") {
          submitData.reimbursed_status = "Reimbursement Pending";
        }
        if (this.detail.type === "project" && this.detail.project) {
          console.log("Project associated with project:", this.detail.project);
          submitData.project = this.detail.project;
          submitData.customer = this.detail.customer;
        }

        if (this.detail.expense_category == 3) {
          if (!this.selectedVisit?.id) {
            this.detail.visit = null;
          }
          if (this.detail.visit) {
            submitData.visit = this.detail.visit;
          }

          if (this.detail.project && this.detail.project > 0) {
            submitData.project = this.detail.project;
          }

          if (this.detail.quotation && this.detail.quotation > 0) {
            submitData.quotation = this.detail.quotation;
          }

          submitData.customer = this.detail.customer;
        } else if (this.detail.expense_category == 4) {
          submitData.customer = this.detail.customer;
          if (this.detail.visit) {
            submitData.visit = this.detail.visit;
            // submitData.customer = this.detail.customer;
          } else if (this.detail.lead_id) {
            submitData.lead = this.detail.lead_id;
          }
        }

        if (this.detail.type === "opportunity" && this.detail.opportunity) {
          submitData.lead = this.detail.opportunity;
          submitData.type = "lead";
        }

        let response;
        if (this.isEditMode) {
          response = await this.$store.dispatch(PUT, {
            url: `claims/${this.editId}`,
            data: submitData,
          });
        } else {
          response = await this.$store.dispatch(POST, {
            url: "claims",
            data: submitData,
          });
        }

        if (response.data && response.data.id) {
          if (typeof ErrorEventBus !== "undefined") {
            SuccessEventBus.$emit(
              "update:success",
              this.isEditMode
                ? "Claim updated successfully!"
                : "Claim created successfully!"
            );
          } else {
            alert(
              this.isEditMode
                ? "Claim updated successfully!"
                : "Claim created successfully!"
            );
          }

          const route = this.getDefaultRoute("claim.detail", {
            params: { id: response.data.id },
          });
          this.$router.push(route);
        } else {
          console.error("No ID in response:", response);
        }
      } catch (error) {
        console.error("Error creating claim:", error);
        this.logError(error);
      } finally {
        this.formLoading = false;
      }
    },
  },

  beforeDestroy() {
    clearTimeout(this.searchTimeout);
    this.customerRequestId += 1;
  },

  computed: {
    isProjectOrQuotationSelected() {
      return !!this.detail.project || !!this.detail.quotation;
    },
    employeesList() {
      if (
        this.detail.expense_category == 3 ||
        this.detail.expense_category == 4
      ) {
        return filter(
          this.employees,
          (row) => row.role_id == 2 || row.role_id == 5
        );
      } else {
        return filter(
          this.employees,
          (row) => row.role_id == 2 || row.role_id == 4
        );
      }
    },
    isFormValid() {
      // const entityValid =
      //   (this.detail.type === "project" && this.detail.project) ||
      //   (this.detail.type === "opportunity" && this.detail.opportunity) ||
      //   (this.detail.type === "visit" && this.detail.visit);
      const isAttachmentValid =
        !this.isAttachmentRequired ||
        (this.detail.attachments && this.detail.attachments.length > 0);

      const isCategoryValid =
        this.detail.expense_category == 3
          ? this.detail.project || this.detail.quotation
          : true;

      const isValid =
        // entityValid &&
        this.detail.title &&
        this.detail.title.trim().length > 0 &&
        this.detail.expense_category &&
        this.detail.payment_mode &&
        this.detail.amount &&
        this.detail.amount > 0 &&
        this.detail.expense_date &&
        this.detail.currency &&
        this.detail.engineer &&
        isCategoryValid &&
        // (this.detail.quotation ||
        // this.detail.project)&&
        isAttachmentValid;
      return isValid;
    },
    selectedProject() {
      // const basicDetails = this.$refs.basicDetails;
      // if (basicDetails && basicDetails.projects && this.detail.project) {
      //   return basicDetails.projects.find(
      //     (proj) => proj.id === this.detail.project
      //   );
      if (this.detail.project) {
        return find(
          this.projects,
          (project) => project.id === this.detail.project
        );
      }
      return null;
    },
    selectedVisit() {
      if (this.detail.visit) {
        return find(this.visits, (visit) => visit.id === this.detail.visit);
      }
      return null;
    },
    selectedQuotation() {
      if (this.detail.quotation) {
        return find(
          this.quotations,
          (quotation) => quotation.id === this.detail.quotation
        );
      }
      return null;
    },
    selectedLead() {
      if (this.detail.lead_id) {
        return find(
          this.leadsListing,
          (lead) => lead.id === this.detail.lead_id
        );
      }
      return null;
    },
    selectedCategory() {
      return this.claimCategories.find(
        (cat) => cat.id == this.detail.expense_category
      );
    },
    isAttachmentRequired() {
      return this.selectedCategory?.attachment_mandatory == "1";
    },
  },

  watch: {
    "detail.customer": {
      handler(newVal, oldVal) {
        if (
          Number(oldVal) > 0 &&
          Number(oldVal) !== Number(newVal || 0)
        ) {
          const hadSelectedVisit = !!this.detail.visit;
          this.detail.visit = null;
          this.visits = [];

          if (hadSelectedVisit && this.detail.type === "visit") {
            this.detail.type = null;
          }
        }
      },
    },
    "detail.expense_category"(newValue) {
      if (newValue) {
        let selectedCategory = find(
          this.expenseCategories,
          (row) => row.id == newValue
        );
        let subcategoryList = [];
        if (selectedCategory && selectedCategory.subcategories.length > 0) {
          subcategoryList = selectedCategory.subcategories;
        }
        if (newValue == 3 && this.detail.engineer) {
          this.fetchVisits();
          this.fetchQuotations();
          this.fetchProjects();
        } else if (newValue == 4 && this.detail.engineer) {
          this.fetchLeads();
        }
        this.subcategoryList = subcategoryList;
        if (this.editId == 0) {
          this.detail.sub_category_name = null;
          this.detail.sub_category = null;
        }
        this.manageCategoryData(selectedCategory);
      }
    },
    expenseCategories(val) {
      if (!this.editId && val.length) {
        this.detail.expense_category = "3";
      }
    },
    isFormValid: {
      handler(newVal) {
        this.formValid = newVal;
      },
      immediate: true,
    },
    "detail.project"() {
      this.$refs.projectField?.validate();
      this.$refs.quotationField?.validate();
    },
    "detail.quotation"() {
      this.$refs.projectField?.validate();
      this.$refs.quotationField?.validate();
    },
  },

  async mounted() {
    await this.initEditMode();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Claim", route: "claim" },
      { title: this.isEditMode ? "Update" : "Create" },
    ]);
  },
};
</script>

<style scoped>
.left-border-red {
  border-left: 4px solid red !important;
}
.left-border-blue {
  border-left: 4px solid #1e88e5 !important;
}

.left-border-green {
  border-left: 4px solid #43a047 !important;
}

.left-border-orange {
  border-left: 4px solid #fb8c00 !important;
}

.left-border-purple {
  border-left: 4px solid #8e24aa !important;
}

.left-border-indigo {
  border-left: 4px solid #3f51b5 !important;
}

.required:after {
  content: " *";
  color: red;
}

.required:after {
  content: " *";
  color: red;
}

.claim-tabs .v-btn {
  background: #e6e6e6 !important;
  color: #777 !important;
  border-radius: 8px !important;
  margin: 0 4px !important;
  padding: 0 4px !important;
  font-size: 12px;
  min-width: 40px !important;
  font-weight: 600 !important;
}

/* active state */
.claim-tabs .v-btn.active {
  color: #fff !important;
}

.claim-tabs .v-btn[value="visit"].active {
  background: #1e88e5 !important;
  /* blue */
}

.claim-tabs .v-btn[value="opportunity"].active {
  background: #43a047 !important;
  /* green */
}

.claim-tabs .v-btn[value="project"].active {
  background: #fb8c00 !important;
  /* orange */
}
</style>
